import { Ref, ref } from '@vue/composition-api';
import { AdgroupFormData, PixelInfo, AD_GROUP_WEBSITE_TYPES } from '@tt4b/ttam-enums';
import { getPixelListWithPagination } from '@tt4b/ttam-hooks';
import { createLogger } from '@tt4b/ttam-utils';
const logger = createLogger('PixelHooks');

export function usePixelListSelectInfiniteScroll(adgroupData: Ref<AdgroupFormData>, alwaysFetchOffSite: Ref<boolean>) {
  const searchKeyword = ref('');

  const isFirstPageLoading = ref(false);
  const isInfiniteScrollLoading = ref(false);
  const isFirstPageError = ref(false);
  const isNextPageError = ref(false);
  const hasLoadedAll = ref(false);

  const currentPage = ref(1);
  const loadedPixelList = ref<PixelInfo[]>([]);

  let serialId = 0;
  async function handlePixelListGet(page = 1, cache?: boolean) {
    const id = ++serialId;

    isFirstPageLoading.value = page === 1;
    isInfiniteScrollLoading.value = page !== 1;
    isFirstPageError.value = false;
    isNextPageError.value = false;

    if (page === 1) {
      loadedPixelList.value = [];
    }

    let loadedInfo: Awaited<ReturnType<typeof getPixelListWithPagination>> | undefined;

    try {
      loadedInfo = await getPixelListWithPagination(
        {
          page,
          promotion_website_type: alwaysFetchOffSite.value
            ? AD_GROUP_WEBSITE_TYPES.offSite
            : adgroupData.value.promotionWebsiteType,
          promotion_target_type: adgroupData.value.promotionTargetType,
          objective_type: adgroupData.value.objectiveType,
          pixel_name: searchKeyword.value,
        },
        cache,
      );
    } catch (e) {
      logger.error(e);
    } finally {
      // 一旦有更加新的请求发生，相对老的结果就直接放弃
      if (id !== serialId) {
        return;
      }

      if (loadedInfo) {
        currentPage.value = page;

        loadedPixelList.value = [...loadedPixelList.value, ...loadedInfo.pixelList];
        hasLoadedAll.value = page === loadedInfo.pagination.page_count;

        // await setPixelList((pixelList as PixelInfo[]) || []);
      } else {
        if (page === 1) {
          isFirstPageError.value = true;
        } else {
          isNextPageError.value = true;
        }
      }

      isFirstPageLoading.value = false;
      isInfiniteScrollLoading.value = false;
    }
  }

  function refresh(cache?: boolean) {
    return handlePixelListGet(1, cache);
  }

  function loadNextPage() {
    if (!isFirstPageLoading.value && !isInfiniteScrollLoading.value && !hasLoadedAll.value) {
      return handlePixelListGet(currentPage.value + 1);
    }
  }

  return {
    searchKeyword,
    loadedPixelList,

    isFirstPageError,
    isNextPageError,
    isFirstPageLoading,
    isInfiniteScrollLoading,

    refresh,
    loadNextPage,
  };
}
